import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthContext = React.createContext(null);

export function AuthProvider(props) {
  const [token, setToken] = React.useState(sessionStorage.getItem('admin_token'));
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  function logout() {
    sessionStorage.removeItem('admin_token');
    setToken(null);
    setUser(null);
  }

  React.useEffect(function() {
    async function verifyToken() {
      if (token) {
        try {
          const response = await axios.get(API_URL + '/api/auth/me', {
            headers: { Authorization: 'Bearer ' + token }
          });
          setUser(response.data);
        } catch (error) {
          console.error('Token verification failed:', error);
          logout();
        }
      }
      setLoading(false);
    }
    verifyToken();
  }, [token]);

  async function login(email, password) {
    const response = await axios.post(API_URL + '/api/auth/login', {
      email: email,
      password: password
    });
    const newToken = response.data.token;
    const userEmail = response.data.email;
    localStorage.removeItem('admin_token');
    sessionStorage.setItem('admin_token', newToken);
    setToken(newToken);
    setUser({ email: userEmail });
    return response.data;
  }

  function getAuthHeaders() {
    return { Authorization: 'Bearer ' + token };
  }

  const value = {
    token: token,
    user: user,
    loading: loading,
    isAuthenticated: !!token && !!user,
    login: login,
    logout: logout,
    getAuthHeaders: getAuthHeaders
  };

  return React.createElement(AuthContext.Provider, { value: value }, props.children);
}

export function useAuth() {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}

export default AuthContext;
